const NONE = { owner: false, site: false, people: false, store: false, buy: false, suppliers: false, money: false, approve: false, settings: false, partner: false };
/** The same split as Buildiary 1.1 (buildiary/field.py caps), plus approve and settings. */
export function capsFor(role) {
    switch (role) {
        case 'owner':
            return { owner: true, site: true, people: true, store: true, buy: true, suppliers: true, money: true, approve: true, settings: true, partner: false };
        case 'owner_supervisor':
            return { ...NONE, site: true, people: true, store: true, buy: true, suppliers: true, money: true, approve: true };
        case 'site_supervisor':
            return { ...NONE, site: true, people: true, store: true, buy: true };
        case 'store_keeper':
            return { ...NONE, store: true };
        case 'accountant':
            return { ...NONE, money: true, suppliers: true, buy: true };
        case 'partner':
            return { ...NONE, site: true, partner: true };
        case 'viewer':
            return { ...NONE };
    }
}
export const ROLES = ['owner', 'owner_supervisor', 'site_supervisor', 'store_keeper', 'accountant', 'partner', 'viewer'];
export const ROLE_LABEL = {
    en: { owner: 'Owner', owner_supervisor: 'Owner’s supervisor', site_supervisor: 'Site supervisor', store_keeper: 'Store keeper', accountant: 'Accountant', partner: 'Builder or consultant', viewer: 'Viewer' },
    ur: { owner: 'مالک', owner_supervisor: 'مالک کا نگران', site_supervisor: 'سائٹ سپروائزر', store_keeper: 'اسٹور کیپر', accountant: 'اکاؤنٹنٹ', partner: 'بلڈر یا کنسلٹنٹ', viewer: 'دیکھنے والا' },
    ar: { owner: 'المالك', owner_supervisor: 'مشرف المالك', site_supervisor: 'مشرف الموقع', store_keeper: 'أمين المخزن', accountant: 'المحاسب', partner: 'المقاول أو الاستشاري', viewer: 'مشاهد' },
};
//# sourceMappingURL=roles.js.map